// extracted by mini-css-extract-plugin
export default {"errorBody":"AppErrorFallback_errorBody__xwu4-","icon":"AppErrorFallback_icon__ukxqZ","buttons":"AppErrorFallback_buttons__WYy22"};